import React from "react";

import "./Pagination.css";

const Pagination = ({
    totalPosts,
    postsPerPage,
    setCurrentPage,
    currentPage,
}) => {
    const pageButtons = 5; // Number of page buttons to display

    let pages = [];
    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
        pages.push(i);
    }

    // Calculate start and end indices
    let start = currentPage - Math.floor(pageButtons / 2);
    let end = currentPage + Math.floor(pageButtons / 2);
    if (start < 1) {
        start = 1;
        end = pageButtons;
    }
    if (end > pages.length) {
        end = pages.length;
        start = pages.length - pageButtons + 1;
    }
    if (start < 1) {
        start = 1;
    }
   

    return (
        <div className='pagination'>
            {start > 1 && (
                <>
                    <button onClick={() => setCurrentPage(1)}>1</button>
                    <span>....</span>
                </>
            )}
            {pages.slice(start - 1, end).map((page, index) => {
                return (
                    <button
                        key={index}
                        onClick={() => {setCurrentPage(page);          window.scrollTo(0, 0);}}
                        className={page === currentPage ? "active" : "inactive "}
                    >
                        {page}
                    </button>
                );
            })}
            {end < pages.length && (
                <>
                    <span>...</span>
                    <button onClick={() =>  setCurrentPage(pages.length) }>
                        {pages.length}
                    </button>
                </>
            )}
        </div>
    );
};

export default Pagination;
